import { Fragment } from "react";
import Footer from "./Footer";
import Header from "./Header";
import LeftBar from "./LeftBar";

const LayoutAuthorized = (props) => {
  return (
    <Fragment>
      <Header />
      {/* <LeftBar /> */}
      {/* <div id="main-wrapper"> */}
      <div>
        <div className="content-body" style={{ height: "100vh !import" }}>
          {props.children}
        </div>
      </div>

      <Footer />
    </Fragment>
  );
};

export default LayoutAuthorized;
